document.addEventListener("DOMContentLoaded", function () {
    // 自動で全てのチェックボックスにチェックをつける
    document.getElementById("mark_as_check")?.addEventListener("click", function () {
        document.querySelectorAll("tr").forEach(function (row) {
            const hasSelection = row.querySelectorAll("input[type='checkbox']:checked").length > 0;

            if (!hasSelection) {
                const availabilityCheckbox = row.querySelector("input[type='checkbox'][id^='availabilities_']");
                const settingCheckbox = row.querySelector("input[type='checkbox'][id^='online_lesson_settings']");
                // disabled属性がついていないチェックボックスのみチェック
                if (availabilityCheckbox && !availabilityCheckbox.disabled) availabilityCheckbox.checked = true;
                if (settingCheckbox && !settingCheckbox.disabled) settingCheckbox.checked = true;
            }
        });
        updateSelectedShifts();
    });

    // 自動で全てのチェックボックスにチェックを外す
    document.getElementById("mark_as_not_check")?.addEventListener("click", function () {
        document.querySelectorAll("input[type='checkbox'][id^='availabilities_'], input[type='checkbox'][id^='online_lesson_settings']").forEach(function (checkbox) {
            // disabled属性がついていないチェックボックスのみチェックを外す
            if (!checkbox.disabled) {
                checkbox.checked = false;
            }
            checkbox.checked = false;
        });
        updateSelectedShifts();
    });

    // チェックボックス変更監視
    document.querySelectorAll("input[type='checkbox'][id^='possible_']").forEach(function (checkbox) {
        checkbox.addEventListener("change", updateSelectedShifts);
    });

    // モーダル表示時に更新
    document.querySelectorAll("[command='show-modal']").forEach(function (el) {
        el.addEventListener("click", updateSelectedShifts);
    });

    /**
     * 確定の確認画面に出す、行の日時とユーザーグループ
     *
     * 行に data-datetime / data-user-group があればそれを使う（講師ポータルの未決定シフト入力。先頭に企業名の列があり、列の位置では読めない）。
     * 無い場合は従来どおり列の位置（日時: 3番目、ユーザーグループ: 4番目）から読む（管理画面の未決定シフト入力）。
     *
     * @param {HTMLTableRowElement} row
     * @returns {{datetime: string, userGroup: string}}
     */
    function readShiftLabels(row) {
        return {
            datetime: row.dataset.datetime ?? (row.children[2]?.textContent.trim() || ''),
            userGroup: row.dataset.userGroup ?? (row.children[3]?.textContent.trim() || ''),
        };
    }

    // シフト選択情報を更新
    function updateSelectedShifts() {
        // 確定シフトのチェックボックスを取得
        const certifiedCheckboxes = Array.from(document.querySelectorAll("input[type='checkbox'][id^='online_lesson_settings']:checked"));

        // 確定シフトの情報を収集
        const finalCertifiedShifts = certifiedCheckboxes.map(checkbox => {
            const row = checkbox.closest("tr");
            const { datetime: datetimeText, userGroup } = readShiftLabels(row);

            return {
                checkbox,
                row,
                datetime: datetimeText,
                userGroup,
                id: checkbox.id.replace('online_lesson_settings', '')
            };
        });

        const finalCertifiedIds = new Set(); // 確定シフトのIDを記録
        finalCertifiedShifts.forEach(shift => {
            finalCertifiedIds.add(shift.id);
        });

        // 希望提出シフトの既存チェック項目を取得（確定シフトを除く）
        const availabilityCheckboxes = document.querySelectorAll("input[type='checkbox'][id^='availabilities_']:checked");
        const availabilityShifts = [];

        availabilityCheckboxes.forEach(function (checkbox) {
            const id = checkbox.id.replace('availabilities_', '');
            // 確定シフトに含まれない場合のみ追加
            if (!finalCertifiedIds.has(id)) {
                const row = checkbox.closest("tr");
                const { datetime, userGroup } = readShiftLabels(row);
                availabilityShifts.push({
                    datetime,
                    userGroup,
                    id,
                    checkbox
                });
            }
        });

        // HTMLを生成
        let certifiedShiftsHtml = '';
        finalCertifiedShifts.forEach(shift => {
            certifiedShiftsHtml += `・${shift.datetime} ${shift.userGroup}<br>`;
        });

        let availabilityShiftsHtml = '';
        availabilityShifts.forEach(shift => {
            availabilityShiftsHtml += `・${shift.datetime} ${shift.userGroup}<br>`;
        });

        // hiddenフィールドを更新
        const hiddenFieldsElement = document.getElementById("hidden_fields");
        if (hiddenFieldsElement) {
            hiddenFieldsElement.innerHTML = '';

            // 確定シフトのhiddenフィールドを追加
            finalCertifiedShifts.forEach(shift => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = `online_lesson_settings[${shift.id}][lecturer_user_id]`;
                input.value = shift.checkbox.value;
                hiddenFieldsElement.appendChild(input);
            });

            // 確定シフトにチェックが入っている場合、希望提出シフトのhiddenフィールドも追加
            // ただし、すでに追加済みのIDは除外して重複を防ぐ
            const addedAvailabilityIds = new Set();

            // 既存の希望提出シフトのhiddenフィールドを追加
            availabilityShifts.forEach(shift => {
                if (!addedAvailabilityIds.has(shift.id)) {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = `availabilities[${shift.id}]`;
                    input.value = '1';
                    hiddenFieldsElement.appendChild(input);
                    addedAvailabilityIds.add(shift.id);
                }
            });

            // 確定シフトとして選択されているものも希望提出シフトのhiddenフィールドに追加
            // （確定シフトにチェックが入っている場合、自動的に希望提出シフトも追加）
            finalCertifiedShifts.forEach(shift => {
                if (!addedAvailabilityIds.has(shift.id)) {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = `availabilities[${shift.id}]`;
                    input.value = '1';
                    hiddenFieldsElement.appendChild(input);
                    addedAvailabilityIds.add(shift.id);
                }
            });

            // チェックが外されたアイテムのhiddenフィールドを追加
            // 初期状態でチェックされていたが、現在チェックされていないものを検出
            document.querySelectorAll('[class*="unavailabilities-"]').forEach(hiddenField => {
                const match = hiddenField.className.match(/unavailabilities-(\d+)/);
                if (match) {
                    const lessonId = match[1];
                    const checkbox = document.getElementById(`availabilities_${lessonId}`);

                    // チェックが外されている場合のみ、unavailabilitiesとして追加
                    if (checkbox && !checkbox.checked && !addedAvailabilityIds.has(lessonId)) {
                        const input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = `unavailabilities[${lessonId}]`;
                        input.value = '3';
                        hiddenFieldsElement.appendChild(input);
                    }
                }
            });
        }

        let finalHtml = '';
        if (certifiedShiftsHtml) {
            finalHtml += '<strong>【確定シフト】：あなたの担当として認定講師必須講座が決定</strong><br>' + certifiedShiftsHtml + '<br>';
        }
        if (availabilityShiftsHtml) {
            finalHtml += '<strong>【希望提出シフト】：希望は「◯」として提出します。運営が確認し、割振られる可能性があります</strong><br>' + availabilityShiftsHtml;
        }

        const selectedShiftsElement = document.getElementById("selected_shifts");
        if (selectedShiftsElement) {
            selectedShiftsElement.innerHTML = finalHtml;
        }
    }
});
